import styled from 'styled-components';
import * as tokens from '../../tokens';

export const TotalWrapper = styled.div`
  width: 1060px;
  height: 320px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-top: 85px;
`;
export const DonationTotalWrapper = styled.div`
  width: 1060px;
  height: 400px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-top: 85px;
`;
export const PageButton = styled.div`
  width: 26px;
  height: 50px;
  color: pink;
  font-size: 40px;
`;
export const RealWrapper = styled.div`
  width: 910px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
`;
export const title = styled.div`
  font-size: 23px;
  font-weight: bold;
  display: flex;
  margin-left: 15px;
  margin-bottom: 10px;
`;
export const cardsWrapper = styled.div`
  width: 908px;
  height: 280px;
  gap: 5px;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const donationcardsWrapper = styled.div`
  width: 908px;
  height: 360px;
  gap: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: blue;
`;
